import { jsx as _jsx } from "react/jsx-runtime";
import { ReactFlow, ReactFlowProvider } from "@xyflow/react";
import { EdgeCrossingProvider, EdgeSpreadingProvider } from "../edges/routing";
export function FlowCanvas(props) {
    const { adapter, nodes, edges, children, className, style, provider = false, ...rest } = props;
    const nodeTypes = adapter.registry.nodeTypes;
    const edgeTypes = adapter.registry.edgeTypes;
    const bridgesEnabled = Boolean(adapter.features?.bridges);
    const spreadEnabled = Boolean(adapter.features?.spreadParallelEdges);
    let tree = /*#__PURE__*/ _jsx(ReactFlow, {
        nodes: nodes,
        edges: edges,
        nodeTypes: nodeTypes,
        edgeTypes: edgeTypes,
        className: className,
        style: style,
        ...rest,
        children: children
    });
    if (spreadEnabled) {
        tree = /*#__PURE__*/ _jsx(EdgeSpreadingProvider, {
            edges: edges,
            nodes: nodes,
            children: tree
        });
    }
    if (bridgesEnabled) {
        tree = /*#__PURE__*/ _jsx(EdgeCrossingProvider, {
            children: tree
        });
    }
    return provider ? /*#__PURE__*/ _jsx(ReactFlowProvider, {
        children: tree
    }) : tree;
}

//# sourceMappingURL=FlowCanvas.js.map